import { MESSAGES_COPY } from '../messages/COPY';

export const LINK_TITLE = {
	MAX: 64,
	MESSAGE: MESSAGES_COPY.INVALID_LINK_TITLE
};
